import { makeStyles } from "@material-ui/core/styles";
export const grupoDetalleStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "0 15px",
    margin: "0",
  },
  title: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    padding: "0",
    margin: "2px 0",
  },
  titlePaquete: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    padding: "0",
    margin: "0",
  },
  containerHead: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0",
    margin: "5px 2rem",
  }
}));